// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { BeneficiaryDTO } from './beneficiary-dto';
import { InsuredItemDTO } from './insured-item-dto';
import { PolicyDocumentDTO } from './policy-document-dto';
import { PolicyStatusDTO } from './policy-status-dto';
import { PolicyTypeDTO } from './policy-type-dto';

/**
 * 
 * @export
 * @interface PolicyDTO
 */
export interface PolicyDTO {
    /**
     * 
     * @type {string}
     * @memberof PolicyDTO
     */
    id: string;
    /**
     * 
     * @type {BeneficiaryDTO}
     * @memberof PolicyDTO
     */
    beneficiary: BeneficiaryDTO;
    /**
     * 
     * @type {string}
     * @memberof PolicyDTO
     */
    legacyInsurerId?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDTO
     */
    status: PolicyDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PolicyDTO
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyDTO
     */
    endDate: string;
    /**
     * 
     * @type {PolicyTypeDTO}
     * @memberof PolicyDTO
     */
    type: PolicyTypeDTO;
    /**
     * 
     * @type {Array<InsuredItemDTO>}
     * @memberof PolicyDTO
     */
    items: Array<InsuredItemDTO>;
    /**
     * 
     * @type {Array<PolicyDocumentDTO>}
     * @memberof PolicyDTO
     */
    documents: Array<PolicyDocumentDTO>;
    /**
     * 
     * @type {Array<PolicyStatusDTO>}
     * @memberof PolicyDTO
     */
    statuses?: Array<PolicyStatusDTO>;
    /**
     * 
     * @type {string}
     * @memberof PolicyDTO
     */
    createdAt: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PolicyDTOStatusEnum {
    DRAFT = 'DRAFT',
    SUBMITTED = 'SUBMITTED',
    ISSUED = 'ISSUED',
    CLOSED = 'CLOSED',
    DEACTIVATED = 'DEACTIVATED',
    UNKNOWN = 'UNKNOWN'
}



